export default __webpack_public_path__ + "static/media/070_boost.836aeb83.mp3";